import { UMNG } from './base';

export const users = {
  notes: `${UMNG}/saved-notes`,
  locations: `${UMNG}/saved-locations`,
  organizationLocations: `${UMNG}/saved-locations/organization-locations`,
  preferences: `${UMNG}/user-preferences`,
};

export default users;
